(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.zhCN = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: '未找到数据'
      },
      combobox: {
        placeholder: '选择',
        searchPlaceholder: '搜索'
      },
      datepicker: {
        apply: '应用',
        clearSelection: '清除',
        pickADays: '选择天',
        prevYear: '上一年',
        nextYear: '下一年',
        prevMonth: '上个月',
        nextMonth: '下个月',
        year: '',
        month1: '1月',
        month2: '2月',
        month3: '3月',
        month4: '4月',
        month5: '五月',
        month6: '6月',
        month7: '7月',
        month8: '8月',
        month9: '9月',
        month10: '10月',
        month11: '11月',
        month12: '12月',
        weeks: {
          sun: '星期日',
          mon: '星期一',
          tue: '星期二',
          wed: '星期三',
          thu: '星期四',
          fri: '星期五',
          sat: '星期六'
        },
        months: {
          jan: '一月',
          feb: '二月',
          mar: '三月',
          apr: '四月',
          may: '五月',
          jun: '六月',
          jul: '七月',
          aug: '八月',
          sep: '九月',
          oct: '十月',
          nov: '十一月',
          dec: '十二月'
        },
        pickADay: '选择一天'
      },
      timepicker: {
        meridiemAM: 'AM',
        meridiemPM: 'PM'
      },
      dropdown: {
        noDataMessage: '未找到数据'
      },
      filepicker: {
        browse: '浏览',
        select: '选择文件'
      },
      filter: {
        apply: '应用',
        cancel: '取消',
        filterButton: '过滤器',
        reset: '重置过滤器',
        resetDefault: '重置为默认值'
      },
      search: {
        noDataMessage: '未找到数据'
      },
      'multi-search': {
        'separator-and': '和',
        'search-button': '搜索',
        'search-placeholder': '按名称搜索'
      },
      select: {
        all: '所有',
        clearSelection: '清除选择',
        noMatch: '未找到数据',
        noData: '无数据',
        placeholder: '选择',
        item: '项目',
        selected: '已选定',
        found: '已找到'
      },
      upload: {
        browseButton: '浏览',
        text: '拖放要上传的文件，或单击“浏览”',
        tip: '您可以上传 10 个文件，每个文件最大 25 MB'
      },
      table: {
        emptyText: '无数据'
      },
      tree: {
        emptyText: '无数据'
      }
    }
  };
  _exports.default = _default;
});